import React, { Component } from 'react';
import { View, Text } from 'core';
import { ContextualMenu, DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';
import { theme } from 'constants';
import { lang } from 'lang';

const styles = {
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 200,
    padding: 5
  },
  item: {
    height: 60
  },
  text: {
    marginHorizontal: 10
  }
};
class ActionSheetProvider extends Component {
  state = {};

  componentDidMount() {
    ActionSheet = this;
  }

  show = ({ options, event, onDismiss }) => {
    this.onDismiss = onDismiss;
    this.target = event.currentTarget;
    this.options =
      options &&
      options.map((obj, index) => {
        const Icon = obj.icon;
        return {
          key: index,
          style: styles.item,
          name: (
            <View style={styles.option}>
              {Icon && <Icon size={24} color={theme.primary_color} />}
              <Text style={styles.text}>{obj.text}</Text>
            </View>
          ),
          onClick: obj.onPress
        };
      });

    this.setState({ is_show: true });
  };

  close = () => this.setState({ is_show: false });

  render() {
    return (
      <View>
        {this.state.is_show ? (
          <ContextualMenu
            items={this.options}
            target={this.target}
            directionalHint={lang.LANG_DIR === 'rtl' ? DirectionalHint.bottomLeftEdge : DirectionalHint.bottomRightEdge}
            onDismiss={() => {
              this.setState({ is_show: false });
              this.onDismiss && this.onDismiss();
            }}
          />
        ) : null}
      </View>
    );
  }
}

let ActionSheet = {};

export { ActionSheet, ActionSheetProvider };



// WEBPACK FOOTER //
// ./src/components/core/action_sheet.web.js